import { StyleSheet, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useNoticeStore } from '@/stores/notice-store'
import { NoticeItem } from '@/ui/NoticeItem'

export function NoticeBannerStack() {
    const notices = useNoticeStore(s => s.notices)
    const dismiss = useNoticeStore(s => s.dismiss)
    const insets = useSafeAreaInsets()

    if (notices.length === 0) return null

    return (
        <View style={styles.container} pointerEvents="box-none" accessibilityLiveRegion="polite">
            {notices.map((n, idx) => (
                <View key={n.id} style={idx === 0 ? { paddingTop: insets.top } : undefined}>
                    <NoticeItem
                        notice={n}
                        variant="banner"
                        onDismiss={() => dismiss(n.id)}
                        showCloseButton={n.dismissible !== false && typeof n.duration === 'number'}
                    />
                </View>
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
})
